import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from 'react'

import {
    Table,
    Row,
    Divider,
    Descriptions,
} from "antd";
import { labelConfig } from "../../../customer.config";


const columns = [
    {
        title: "Expected Disbursement On",
        dataIndex: "expectedDisbursementOn",
    },

    {
        title: "Disbursement On",
        dataIndex: "disbursementOn",
    },
    {
        title: "Principal",
        dataIndex: "principal",
    },
];

const LoanTrancheDetails = (props) => {
    const { disbursementDetailsList, accountDetails } = props;

    const items = [
        {
            label: labelConfig.maximumAllowedOutstandingBalance,
            children: accountDetails?.maxOutstandingLoanBalance ? accountDetails?.maxOutstandingLoanBalance : "-"
        },
        {
            label: labelConfig.installmentAmountVariations,
            children: accountDetails?.installmentAmountVariations ? accountDetails?.installmentAmountVariations : "-"
        },

    ];

    return (
        <>
            <Row >

                <Descriptions
                    bordered
                    column={{
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}
                    style={{ marginTop: 10, marginBottom: 20 }}
                    items={items}
                />
            </Row>

            <Divider orientation="left"></Divider>

            <Table
                columns={columns}
                dataSource={disbursementDetailsList}
            ></Table>
        </>
    )
}

export default LoanTrancheDetails



